export const roleModalName = 'RoleModal';
export const assignRoleModalName = 'AssignModal';
export const waitOverlayName = 'fetchingOrganizationRoles';